import { SVGProps, Ref, forwardRef } from 'react'
const SvgHRstar = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg
    width="1.5rem"
    height="1.5rem"
    fill="none"
    viewBox="0 0 20 21"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <g
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      clipPath="url(#HRstar_svg__a)"
    >
      <path d="M18.203 19.48v-.725a1.581 1.581 0 0 0-.616-1.261c-1.066-.814-3.038-2.116-7.617-2.116-4.579 0-6.55 1.302-7.617 2.116a1.58 1.58 0 0 0-.615 1.261v.725" />
      <path d="m11.57 19.48-1.6-4.102-1.597 4.102M15.83 19.48h-1.758M10.671 2.322l1.505 3.976h2.93a.718.718 0 0 1 .506 1.25l-2.543 1.77 1.406 3.236a.767.767 0 0 1-1.093.96l-3.405-1.916-3.402 1.918a.766.766 0 0 1-1.093-.96l1.406-3.234-2.54-1.77a.717.717 0 0 1 .504-1.25h2.93L9.29 2.324a.781.781 0 0 1 1.382-.003Z" />
    </g>
    <defs>
      <clipPath id="HRstar_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" transform="translate(0 .69)" />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgHRstar)
export default ForwardRef
